export default "__VITE_ASSET__ClbYRRbI__"